module.exports = fetch;


//////////////////
// WEBPACK FOOTER
// external "fetch"
// module id = 6
// module chunks = 0